import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import './styles/global.css';
import HomePage from './pages/HomePage';
import ProductDetail from './pages/ProductDetail';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import SocialLoginPage from './pages/SocialLoginPage';
import MyPage from './pages/MyPage';
import CartPage from './pages/CartPage';
import OrderPage, { OrderCompletePage } from './pages/OrderPage';
import OrderLookupPage from './pages/OrderLookupPage';
import CategoryPage from './pages/CategoryPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import {
  HelpPage, FAQPage, ShippingPage, ReturnPolicyPage,
  HowToOrderPage, PaymentPage, DeliveryPage, BuyerProtectionPage,
  AboutPage, TermsPage, PrivacyPage, ContactPage
} from './pages/InfoPages';

function App() {
  return (
    <BrowserRouter basename="/shop">
      <AuthProvider>
        <CartProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/category/:categoryId" element={<CategoryPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/login/social" element={<SocialLoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/order" element={<OrderPage />} />
            <Route path="/order/complete" element={<OrderCompletePage />} />
            <Route path="/order/lookup" element={<OrderLookupPage />} />
            {/* 고객센터 */}
            <Route path="/help" element={<HelpPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/shipping" element={<ShippingPage />} />
            <Route path="/return-policy" element={<ReturnPolicyPage />} />
            {/* 쇼핑 가이드 */}
            <Route path="/how-to-order" element={<HowToOrderPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/delivery" element={<DeliveryPage />} />
            <Route path="/buyer-protection" element={<BuyerProtectionPage />} />
            {/* 월드쉽 소개 */}
            <Route path="/about" element={<AboutPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
